import apiClient from "../utils/apiClient";
import {
  LOAD_ALL_USERS_REQUEST,
  LOAD_ALL_USERS_SUCCESS,
  LOAD_ALL_USERS_FAIL,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_RESET,
  UPDATE_PROFILE_FAIL,
  ASSIGN_ROLE_REQUEST,
  ASSIGN_ROLE_SUCCESS,
  ASSIGN_ROLE_FAIL,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CLEAR_ERRORS,
} from "../constants/userConstants";
const API_PREFIX = process.env.REACT_APP_API_PREFIX || "";
//get all users
export const getUsers = () => async (dispatch) => {
  try {
    dispatch({
      type: LOAD_ALL_USERS_REQUEST,
    });
    const { data } = await apiClient.get(`${API_PREFIX}/admin/users`);
    dispatch({
      type: LOAD_ALL_USERS_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: LOAD_ALL_USERS_FAIL,
      payload: err,
    });
  }
};

//Add User
export const addUser =
  (
    first_name,
    last_name,
    email,
    dob,
    mobile_code,
    mobile_number,
    nationality,
    gender,
    accountStatus,
    password,
    confirm_password,
    roleId
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: ADD_USER_REQUEST,
      });
      const config = {
        headers: {
          //"content-type": "multipart/form-data",
          "content-type": "application/json",
        },
      };
      // console.log("userData ", userData.getAll());
      // return;
      const { data } = await apiClient.post(
        `${API_PREFIX}/admin/users/add`,
        // userData,
        {
          first_name,
          last_name,
          email,
          dob,
          mobile_code,
          mobile_number,
          nationality,
          gender,
          accountStatus,
          password,
          confirm_password,
          roleId: roleId || null,
        },
        config
      );
      if (!data) {
        dispatch({
          type: ADD_USER_FAIL,
          payload: "Invalid email or password",
        });
      }
      dispatch({
        type: ADD_USER_SUCCESS,
        payload: data.user,
      });
    } catch (error) {
      var errorMsg = error.response.data.errMessage;
      if (
        error.response.data.error !== undefined &&
        error.response.data.error.code === 11000
      ) {
        errorMsg = "Entered email already exist, please try another.";
      }
      dispatch({
        type: ADD_USER_FAIL,
        payload: errorMsg,
        errors: error.response.data,
      });
    }
  };

// Update user profile
export const updateUserProfile =
  (
    userId,
    first_name,
    last_name,
    mobile_code,
    mobile_number,
    email,
    dob,
    gender,
    nationality,
    accountStatus,
    roleId
  ) =>
  async (dispatch) => {
    //console.log('userData ', userData);
    try {
      dispatch({
        type: UPDATE_PROFILE_REQUEST,
      });

      const config = {
        // headers: {
        //     'Content-Type': 'multipart/form-data'
        // }
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await apiClient.put(
        `${API_PREFIX}/admin/users/${userId}`,
        {
          first_name,
          last_name,
          mobile_code,
          mobile_number,
          email,
          dob,
          gender,
          nationality,
          accountStatus,
          roleId: roleId || null,
        },
        config
      );

      dispatch({
        type: UPDATE_PROFILE_SUCCESS,
        payload: data.success,
      });
    } catch (error) {
      var errorMsg = error.response.data.errMessage;
      if (
        error.response.data.error !== undefined &&
        error.response.data.error.code === 11000
      ) {
        errorMsg = "Entered email already exist, please try another.";
      }
      dispatch({
        type: UPDATE_PROFILE_FAIL,
        payload: errorMsg,
        errors: error.response.data,
      });
    }
  };

//clear errors
export const clearErrors = () => async (dispatch) => {
  dispatch({
    type: CLEAR_ERRORS,
  });
};

// Assign role to a user
export const assignRole = (userId, roleId) => async (dispatch) => {
  try {
    dispatch({ type: ASSIGN_ROLE_REQUEST });

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    const { data } = await apiClient.put(
      `${API_PREFIX}/admin/users/${userId}/role`,
      { roleId: roleId || null },
      config
    );

    dispatch({
      type: ASSIGN_ROLE_SUCCESS,
      payload: data.user,
    });
  } catch (error) {
    dispatch({
      type: ASSIGN_ROLE_FAIL,
      payload: error.response?.data?.errMessage || error.message,
    });
  }
};

// Admin change user password
export const changeUserPassword = (userId, newPassword, sendEmail = false) => async (dispatch) => {
  try {
    dispatch({ type: CHANGE_PASSWORD_REQUEST });

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    const { data } = await apiClient.put(
      `${API_PREFIX}/admin/users/${userId}/change-password`,
      { password: newPassword, sendEmail },
      config
    );

    dispatch({
      type: CHANGE_PASSWORD_SUCCESS,
      payload: data.success,
    });
  } catch (error) {
    dispatch({
      type: CHANGE_PASSWORD_FAIL,
      payload: error.response?.data?.errMessage || error.response?.data?.message || error.message,
    });
  }
};
